module.exports = __webpack_public_path__ + "img/ums-menu.0c11c96a.svg";